import type { ProviderRow } from "@/app/types/Provider";

type ProviderNameSource =
  | Partial<Pick<ProviderRow, "title" | "first_name" | "last_name">>
  | null
  | undefined;

export function getProviderDisplayName(provider: ProviderNameSource): string {
  if (!provider) return "";

  const parts = [provider.title, provider.first_name, provider.last_name]
    .map((p) => (typeof p === "string" ? p.trim() : ""))
    .filter(Boolean);

  if (parts.length > 0) {
    return parts.join(" ");
  }

  return "";
}
